import "./App.css";
import RegistrationSuccess from "./components/RegistrationSuccess";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TicketRegistrationForm from "./components/Registration";

function App() {
  return (
    <Router basename={"/"}>
      <Routes>
        {/* TODO: add 404 route if no id is passed or wrong id */}
        <Route
          path="/:id"
          element={<TicketRegistrationForm></TicketRegistrationForm>}
        />
        <Route
          path="success/:id"
          element={<RegistrationSuccess></RegistrationSuccess>}
        />
      </Routes>
    </Router>
  );
}

export default App;
